import { handleActions } from "redux-actions";
import actionCreators from "../../actions/service/index_of_not_signed_in";

const initialState = {
  isWebViewTabApp: false,
  circles: [],
  newArrivalCircles: [],
  events: [],
  blogs: [],
  reports: [],
  serviceName: "",
};

export default handleActions(
  {
    [actionCreators.service.indexOfNotSignedIn.set]: (state, action) =>
      Object.assign({}, state, action.payload),
  },
  initialState
);
